import { FC } from "react";
import { useHistory } from "react-router-dom";
import { useTranslation } from "react-i18next";
import { FlexBox } from "@brg/ui";
import { BackButtonContainer } from "./styles";

interface IProps {
    onBackClick?: () => void;
    buttonText?: string;
}


export const ProjectMetaBack: FC<IProps> = ({ 
    onBackClick,
    buttonText
}) => {
    const history = useHistory();
    const { t } = useTranslation();

    const goBack = () => {
        if (!!onBackClick) {
            onBackClick?.()
            return;
        }
        history.goBack()
    }

    return <BackButtonContainer>
        <FlexBox className={'inner-container'} direction="row" onClick={goBack} gx={4} align="center">
            <svg width="16" height="16" viewBox="0 0 16 16" fill="none" xmlns="http://www.w3.org/2000/svg">
            <path d="M5.84199 8L11.7765 13.7402C12.0745 14.0284 12.0745 14.4957 11.7765 14.7839C11.4786 15.0721 10.9955 15.072 10.6975 14.7838L4.22347 8.52183C3.92551 8.23363 3.92551 7.76637 4.22347 7.47817L10.6975 1.21615C10.9955 0.927951 11.4786 0.927949 11.7765 1.21615C12.0745 1.50435 12.0745 1.97161 11.7765 2.25981L5.84199 8Z" fill="#909090"/>
            </svg>
            <span>{buttonText || t('competition_edit.back')}</span>
        </FlexBox>
    </BackButtonContainer>
}import { FC } from "react";
import { useHistory } from "react-router-dom";
import { useTranslation } from "react-i18next";
import { FlexBox } from "@brg/ui";
import { BackButtonContainer } from "./styles";

interface IProps {
    onBackClick?: () => void;
    buttonText?: string;
}


export const ProjectMetaBack: FC<IProps> = ({ 
    onBackClick,
    buttonText
}) => {
    const history = useHistory();
    const { t } = useTranslation();

    const goBack = () => {
        if (!!onBackClick) {
            onBackClick?.()
            return;
        }
        history.goBack()
    }

    return <BackButtonContainer>
        <FlexBox className={'inner-container'} direction="row" onClick={goBack} gx={4} align="center">
            <svg width="16" height="16" viewBox="0 0 16 16" fill="none" xmlns="http://www.w3.org/2000/svg">
            <path d="M5.84199 8L11.7765 13.7402C12.0745 14.0284 12.0745 14.4957 11.7765 14.7839C11.4786 15.0721 10.9955 15.072 10.6975 14.7838L4.22347 8.52183C3.92551 8.23363 3.92551 7.76637 4.22347 7.47817L10.6975 1.21615C10.9955 0.927951 11.4786 0.927949 11.7765 1.21615C12.0745 1.50435 12.0745 1.97161 11.7765 2.25981L5.84199 8Z" fill="#909090"/>
            </svg>
            <span>{buttonText || t('competition_edit.back')}</span>
        </FlexBox>
    </BackButtonContainer>
}